'use strict';

var config = [

    {

        route: '/company/:company_url',

        method: ['GET'],

        controller: 'renderCompany',

        view: {
            route: 'company/:company_url',
            alias: 'company',
            file: 'js/company.js'
        },

        timeout: 2000

    }

];

exports.config = config;

